/**
 * AclsIntersections controller
 *
 * @class AclsIntersections
 * Show acls intersections
 *
 * @ngdoc controller
 * @name mwApp/subscribers.controller:AclsIntersections
 */
/* @ngInject */
export default function AclsIntersections ($uibModalInstance, list) {
  const vm = this

  const fields = ['network', 'country']

  vm.list = list.map(string => Object.fromEntries(string.split(': ').map((item, index) => [fields[index], item])))

  vm.moreNetworksItersections = false

  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
